<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  showLabel: {
    type: Boolean,
    default: true,
  },
  label: {
    type: String,
    required: true,
  },
  labelPosition: {
    type: String,
    default: 'right',
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['update:modelValue', 'action'])

const switchState = () => {
  if (props.disabled) return
  emits('update:modelValue', !props.modelValue)
  emits('action', !props.modelValue)
}

const state = computed(() => {
  return props.modelValue
})
</script>

<template>
  <div class="switch-component">
    <div
      :id="label.includes(' ') ? label.split(' ').join('-') : label"
      class="switch"
      :class="{ on: state, off: !state, 'opacity-50': disabled }"
      @click="switchState"
    >
      <div class="switch-knob"></div>
    </div>
    <label
      v-show="showLabel"
      :for="label"
      class="switch-label control-label"
      :class="{ right: labelPosition === 'right', left: labelPosition === 'left' }"
      >{{ label }}</label
    >
  </div>
</template>

<style scoped>
.switch-component {
  display: flex;
  align-items: center;
  gap: var(--gap-s, 12px);
  padding: var(--gap-4xs, 4px) 0;
}

.switch-label {
  flex-grow: 1;
}

.switch-label.right {
  order: 1;
}

.switch-label.left {
  order: -1;
}

.switch {
  position: relative;
  display: flex;
  align-items: center;
  width: 1.4rem;
  padding: var(--gap-5xs, 2px);
  border-radius: var(--rad-max, 50px);
  cursor: pointer;
  flex-shrink: 0;
}

.switch-knob {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: var(--rad-max, 2px);
  transition: all 150ms ease-in-out;
}

.switch.on {
  border: 1px solid var(--idi-green, #1b92a6);
}

.switch.on .switch-knob {
  transform: translateX(100%);
  background-color: var(--idi-green, #1b92a6);
}

.switch.off {
  border: 1px solid var(--idi-shade4-100, rgb(149, 152, 156));
}

.switch.off .switch-knob {
  transform: translateX(0%);
  background-color: var(--idi-shade4-100, rgb(149, 152, 156));
}
</style>
